import { EmbeddedRecordsMixin } from '@ember-data/serializer/rest';
import type Store from '@ember-data/store';
import type { ModelSchema } from '@ember-data/store/types';
import type { BeniMarketCompositionMarket } from 'lumen/models';
import ApplicationSerializer from 'lumen/serializers/application';

// eslint-disable-next-line @typescript-eslint/no-unsafe-call
export default class BeniMarketCompositionSerializer extends ApplicationSerializer.extend(
  EmbeddedRecordsMixin,
) {
  attrs = {
    markets: { embedded: 'always' },
  };

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  normalizeResponse(
    store: Store,
    primaryModelClass: ModelSchema,
    payload: BeniMarketCompositionMarket,
    id: string | number,
    requestType: string,
  ) {
    const normalizedPayload = {
      'benchmark-insight/market-composition': payload,
    };

    // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-return
    return super.normalizeResponse(
      store,
      primaryModelClass,
      normalizedPayload,
      id,
      requestType,
    );
  }
}
